export const LOAD_BAR = {
  START: '10',
  CNPJ: '24',
  CNAE: '36',
  PARTNERS: '48',
  ADDRESS: '60',
  PSRS: '72',
  BANK: '84',
  TERMS: '100'
};
